// extracted by mini-css-extract-plugin
module.exports = {"containerTaxonomy":"styles_containerTaxonomy__3AQb_"};